<dialog id="passwordDialog">
  <!-- The <form> keeps Chrome from reporting a password field outside a form, so the
       field can be type="password". pdf.js handles the buttons and the Enter key itself:
       the buttons don't submit, and submitting (Enter) mustn't reload the page. -->
  <form (submit)="$event.preventDefault()">
    <div class="row">
      <label for="password" id="passwordText" data-l10n-id="pdfjs-password-label">Enter the password to open this PDF file:</label>
    </div>
    <div class="row">
      <input type="password" id="password" class="toolbarField" autocomplete="off" />
    </div>
    <div class="buttonRow">
      <!-- pdf.js 6.3 renamed .dialogButton to .secondaryButton / .primaryButton; both classes are
           emitted so the same template styles correctly against the 6.2 (assets) and 6.3
           (bleeding-edge) bundles. -->
      <button type="button" id="passwordCancel" class="dialogButton secondaryButton"><span data-l10n-id="pdfjs-password-cancel-button">Cancel</span></button>
      <button type="button" id="passwordSubmit" class="dialogButton primaryButton"><span data-l10n-id="pdfjs-password-ok-button">OK</span></button>
    </div>
  </form>
</dialog>
